import { EXERCISE_TYPES } from "../exercises/types";

export type WorkoutsResponse = Omit<Workout, "data"> & {
  data: string;
};

export const WORKOUT_TYPES = {
  DEFAULT: "DEFAULT",
  TEMPLATE: "TEMPLATE",
} as const;

export interface Workout {
  data: WorkoutsWeek[];
  workoutType: keyof typeof WORKOUT_TYPES;
  name?: string;
  note?: string;
  id: number;
  userId?: number;
  createdAt?: number | null;
  // Non-null = scheda soft-deleted (visibile solo nello Storico).
  deletedAt?: number | null;
  idContainer?: number | null;
  trainer: {
    id: number;
    name: string;
    surname: string;
  };
}

export type WorkoutContainer = {
  id: number;
  name: string;
  color?: string;
  parentId?: number | null;
};

export type WorkoutContainerFromApi = {
  id: number;
  name: string;
  idUser?: number;
  color?: string;
  parentId?: number | null;
};

export type WorkoutsWeek = {
  id: number | null;
  weekNumber: number;
  idWorkout: number;
  days: WorkoutsDay[];
  feedbackForm?: WorkoutWeekFeedbackForm | null;
};

export type WorkoutWeekFeedbackForm = {
  questions: FeedbackQuestion[];
  completed: boolean;
  date: number;
};

export type FeedbackQuestion = {
  id: keyof typeof FEEDBACK_QUESTION_IDS;
  value: string;
};

export const FEEDBACK_QUESTION_IDS = {
  MUSCLE_TARGETED: "MUSCLE_TARGETED",
  MUSCLE_SORENESS: "MUSCLE_SORENESS",
  PHYSICAL_TIREDNESS: "PHYSICAL_TIREDNESS",
  EXERCISE_WEIGHT: "EXERCISE_WEIGHT",
  DIET_QUANTITY: "DIET_QUANTITY",
  DIET_QUALITY: "DIET_QUALITY",
  SLEEP_QUALITY: "SLEEP_QUALITY",
  // keep these for backward compatibility
  GENERAL_ENERGY: "GENERAL_ENERGY",
  JOINT_MUSCLE_PAIN: "JOINT_MUSCLE_PAIN",
  WORKOUT_PERFORMANCE: "WORKOUT_PERFORMANCE",
  TRAINING_MOTIVATION: "TRAINING_MOTIVATION",
  RESTING_HEART_RATE: "RESTING_HEART_RATE",
  HEART_RATE_VARIABILITY: "HEART_RATE_VARIABILITY",
  DIET_ADHERENCE: "DIET_ADHERENCE",
} as const;

export type WorkoutsDay = {
  id: number | null;
  dayNumber: number;
  idWeek: number | null;
  exercises: WorkoutExercise[];
};

export type WorkoutExercise = {
  exercise: Exercise;
};

export type Exercise = {
  id: number | string;
  name: string;
  tags?: string[];
  videoUrls?: string[];
  muscleDistribution?: { district: string; percentage: number }[];
  specialCategoryId?: number;
  checkDistrict?: string;
  subExercises?: { id: string; name: string }[];
  type: keyof typeof EXERCISE_TYPES;
  sets: ExerciseSetFromServer[];
  completed: boolean;
  notes: string;
};

export type Reps =
  | number
  | number[]
  | { id: string; name: string; value: number }[];

export type ExerciseSetFromServer = {
  reps: Reps;
  repsDone?: Reps;
  repsRange?: Reps;
  rest: number;
  weight?: number | number[] | { id: string; name: string; value: number }[];
  completed?: boolean;
  topSet?: boolean;
};

export type WorkoutPreview = {
  id: string;
  workoutType: keyof typeof WORKOUT_TYPES;
  userId?: string;
  user?: {
    id: string;
    name: string;
    surname: string;
  };
  trainer?: {
    id: string;
    name: string;
    surname: string;
  };
};
export type WorkoutTemplatePreview = {
  id: string;
  name: string;
  note: string;
  workoutType: keyof typeof WORKOUT_TYPES;
  idContainer?: number | null;
  trainer?: {
    id: string;
    name: string;
    surname: string;
  };
};

export type GenericWorkout = WorkoutPreview | WorkoutTemplatePreview;

export type AllWorkoutResponse = GenericWorkout[];
